import { render } from "./ViewInvites.vue?vue&type=template&id=26e99f94"
import script from "./ViewInvites.vue?vue&type=script&lang=js"
export * from "./ViewInvites.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\khurr\\OneDrive\\desktop\\development\\refinedhealthpros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__